export const PAYPAL_LEGAL_LINKS = {
    terms: {
        us: 'https://www.paypal.com/us/legalhub/paypal/useragreement-full',
        caEn: 'https://www.paypal.com/ca/legalhub/paypal/useragreement-full?locale.x=en_CA',
        caFr: 'https://www.paypal.com/ca/legalhub/paypal/useragreement-full?locale.x=fr_CA'
    },
    privacy: {
        us: 'https://www.paypal.com/us/legalhub/paypal/privacy-full',
        caEn: 'https://www.paypal.com/ca/legalhub/paypal/privacy-full?locale.x=en_CA',
        caFr: 'https://www.paypal.com/ca/legalhub/paypal/privacy-full?locale.x=fr_CA'
    }
};

export const PAYPAL_WINDOW_CLOSED = 'window is closed';

export const PAY_PAL = 'PAY_PAL';

export const PAYPAL_API_ERROR = {
    // is expected for New user flow
    UNAUTHORIZED: 403,

    // is a flag from API that they ignored Paypal address
    INVALID_LOCALE: -10182
};
